module.exports = __webpack_public_path__ + "img/hp-knife-sapphire.c1e86d92.png";